import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Access-Control-Allow-Origin': '*',
}

// const healthURL = 'https://api.mazola.com.sa/health';
// const baseURL1 = 'https://api.mazola.com.sa/api/v1';
// const baseURL2 = 'https://api.mazola.com.sa/api/v2';

// const healthURL = 'https://mazola-api.onrender.com/health';
// const baseURL1 = 'https://mazola-api.onrender.com/api/v1';
// const baseURL2 = 'https://mazola-api.onrender.com/api/v2';

const healthURL = 'https://mazola-api.onrender.com/health';
const baseURL1 = 'https://mazola-api.onrender.com/api/v1';
const baseURL2 = 'https://mazola-api.onrender.com/api/v2';

const AxiosInstanceV1 = axios.create({
    headers,
});

// @ts-ignore
window.axiostoken = AxiosInstanceV1;
AxiosInstanceV1.get(healthURL);
AxiosInstanceV1.defaults.baseURL = baseURL1;

const AxiosInstanceV2 = axios.create({
  headers
});

AxiosInstanceV2.defaults.baseURL = baseURL2;


ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
  );
  
  // If you want to start measuring performance in your app, pass a function
  // to log results (for example: reportWebVitals(console.log))
  // or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
  reportWebVitals();
  
  export { AxiosInstanceV1, AxiosInstanceV2 };